import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { Field } from 'redux-form';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import type { RootState } from 'af-reducers';

import { Button } from '@acceligentllc/storybook';

import Input from 'af-fields/Input';

import CustomModal from 'af-components/CustomModal';

interface OwnProps {
	showModal: boolean;
	level: 'Company' | 'Job';
	submitDisabled: boolean;
	onSubmit: () => void;
	close: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const MaterialMarkupsAdjustmentModal: React.FC<Props> = (props) => {
	const { showModal, timezone, level, submitDisabled, close, onSubmit } = props;

	const tomorrow = React.useMemo(() => {
		if (!timezone) {
			return null;
		}
		const now = new Date();
		const nowInCompanyTimezoneISO = TimeUtils.adjustDateToTimezone(now.toISOString(), timezone, TimeFormat.ISO_DATETIME);
		const tomorrowInCompanyTimezone = TimeUtils.addDays(nowInCompanyTimezoneISO, 1, TimeFormat.ISO_DATETIME);
		return TimeUtils.formatDate(tomorrowInCompanyTimezone, TimeFormat.DATE_ONLY);
	}, [timezone]);

	return (
		<CustomModal modalStyle="warning" showModal={showModal}>
			<CustomModal.Header
				closeModal={close}
				title={`Edit Rates on ${level} Level?`}
			/>
			<CustomModal.Body>
				<form>
					<Row className="row--padded-top">
						<Col md={8}>
							<Field
								addonAfter="%"
								component={Input}
								isRequired={true}
								isZeroIfEmpty={true}
								label="Shipping Markup"
								name="shippingMarkup"
								placeholder="Enter Shipping"
								type="number"
								withThousandsSeparator={true}
							/>
						</Col>
						<Col md={8}>
							<Field
								addonAfter="%"
								component={Input}
								isRequired={true}
								isZeroIfEmpty={true}
								label="Sales Markup"
								name="salesMarkup"
								placeholder="Enter Sales Markup"
								type="number"
								withThousandsSeparator={true}
							/>
						</Col>
						<Col md={8}>
							<Field
								addonAfter="%"
								component={Input}
								isRequired={true}
								isZeroIfEmpty={true}
								label="Tax"
								name="tax"
								placeholder="Enter Tax"
								type="number"
								withThousandsSeparator={true}
							/>
						</Col>
					</Row>
					<Row>
						<span>New rate(s) will be applied and valid from <b>tomorrow, {tomorrow}</b>. Continue?</span>
					</Row>
				</form>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={close}
					style="secondary"
				/>
				<Button
					disabled={submitDisabled}
					label="Save New Rates"
					onClick={onSubmit}
					style="primary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapStateToProps(state: RootState) {
	const { user: { companyData } } = state;

	if (!companyData) {
		throw new Error('Not logged in');
	}

	return {
		timezone: companyData.timezone ?? null,
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(MaterialMarkupsAdjustmentModal);
